var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInTransit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.556 8.05013L14.321 3.06912C12.948 1.97712 11.028 1.97613 9.649 3.07113L3.459 8.03813C2.702 8.61212 2.261 9.48312 2.25 10.4361V21.0061C2.25 21.4201 2.586 21.7561 3 21.7561C3.414 21.7561 3.75 21.4201 3.75 21.0061V10.4441C3.755 9.96712 3.98 9.52612 4.382 9.22112L10.585 4.24313C11.41 3.58913 12.563 3.58713 13.386 4.24213L19.641 9.23712C20.015 9.51612 20.243 9.96812 20.249 10.4361V21.0061C20.249 21.4201 20.585 21.7561 20.999 21.7561C21.413 21.7561 21.749 21.4201 21.749 21.0061V10.4251C21.735 9.48213 21.282 8.58913 20.556 8.05013Z",
    fill: "#DCB900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9108 15.9496C13.9108 16.3696 13.5708 16.6996 13.1608 16.6996H10.8408C10.4308 16.6996 10.0908 16.3696 10.0908 15.9496C10.0908 15.5396 10.4308 15.1996 10.8408 15.1996H13.1608C13.5708 15.1996 13.9108 15.5396 13.9108 15.9496ZM13.9708 12.0996H10.0308C8.42078 12.0996 7.30078 13.2696 7.30078 14.9396V18.6496C7.30078 20.3296 8.42078 21.4996 10.0308 21.4996H13.9708C15.5808 21.4996 16.7008 20.3296 16.7008 18.6496V14.9396C16.7008 13.2696 15.5808 12.0996 13.9708 12.0996Z",
    fill: "#DCB900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInTransit);
export default __webpack_public_path__ + "static/media/in_transit.803f32029e06a46af6005d64138144d2.svg";
export { ForwardRef as ReactComponent };